import React from 'react'
import { Link } from 'react-router-dom'
import { Navigate,Outlet } from 'react-router-dom'
import { Context } from '../../utils/context'
import { useContext } from 'react'

const  OrderRoute = ({isautentication , children}) => {
    const { orderRoutes} = useContext(Context);

    if(orderRoutes==false){
        return <Navigate to="/" />
    }

  return children
   
    
  
}

export default OrderRoute